export const DOCUMENT_FETCH_INTERVAL_MS = 8000;
